import React from 'react'
import { Link } from 'react-router-dom'
import { useSettingsStore } from '../stores/settingsStore'
import { useTranslation } from 'react-i18next'
import SocialLinks from './SocialLinks'

const FooterTwo = () => {

    const settings = useSettingsStore((state) => state.settings)
    const { t } = useTranslation()

    return (
        <footer className="footer py-80">
            <div className="container container-lg">
                <div className="tw-flex tw-flex-wrap tw-gap-16 tw-justify-between">
                    <div className="footer-item max-w-275">
                        <h6 className="">{settings.store_name}</h6>
                        <p className="mb-24">
                            {settings.store_description}
                        </p>
                        <div className="gap-16 mb-16 flex-align">
                            <span className="flex-shrink-0 w-32 h-32 border border-gray-100 flex-center rounded-circle text-main-two-600 text-md">
                                <i className="ph-fill ph-phone-call" />
                            </span>
                            <Link
                                to={`tel:${settings.store_phone}`}
                                className="text-gray-900 text-md hover-text-main-600"
                            >
                                {settings.store_phone}
                            </Link>
                        </div>
                        <div className="gap-16 mb-16 flex-align">
                            <span className="flex-shrink-0 w-32 h-32 border border-gray-100 flex-center rounded-circle text-main-two-600 text-md">
                                <i className="ph-fill ph-envelope" />
                            </span>
                            <Link
                                to={`mailto:${settings.store_email}`}
                                className="text-gray-900 text-md hover-text-main-600 tw-whitespace-nowrap"
                            >
                                {settings.store_email}
                            </Link>
                        </div>
                        <div className="gap-16 mb-16 flex-align">
                            <span className="flex-shrink-0 w-32 h-32 border border-gray-100 flex-center rounded-circle text-main-two-600 text-md">
                                <i className="ph-fill ph-map-pin" />
                            </span>
                            <span className="text-gray-900 text-md ">
                                {settings.store_address}
                            </span>
                        </div>
                    </div>
                    <div className="footer-item">
                        <h6 className="footer-item__title">{t('footer.aboutUs')}</h6>
                        <ul className="footer-menu">
                            {/* <li className="mb-16">
                                <Link to="/contact" className="text-gray-600 hover-text-main-600">
                                    {t('footer.contactUs')}
                                </Link>
                            </li> */}
                            <li className="mb-16">
                                <Link to="/shipping-policy" className="text-gray-600 hover-text-main-600">
                                    {t('footer.shippingPolicy')}
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/privacy-policy" className="text-gray-600 hover-text-main-600">
                                    {t('footer.privacyPolicy')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-item">
                        <h6 className="footer-item__title">{t('footer.myAccount')}</h6>
                        <ul className="footer-menu">
                            <li className="mb-16">
                                <Link to="/profile" className="text-gray-600 hover-text-main-600">
                                    {t('footer.myAccount')}
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/orders" className="text-gray-600 hover-text-main-600">
                                    {t('footer.orderHistory')}
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/cart" className="text-gray-600 hover-text-main-600">
                                    {t('footer.shoppingCart')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-item">
                        <h6 className="">{t('footer.followUs')}</h6>
                        <SocialLinks settings={settings} style="footer-two" />
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default FooterTwo